import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/taxi-car.svg'


const _hoisted_1 = { class: "p-4 text-center bg-white mt-[70px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("p", { class: "font-medium text-lg" }, "Приложение отключено", -1),
    _createElementVNode("p", { class: "mt-2" }, " Данное приложение было отключено. Свяжитесь с партнером для уточнения новой ссылки на приложение ", -1),
    _createElementVNode("img", {
      src: _imports_0,
      class: "w-5/6 mx-auto",
      alt: "Taxi car"
    }, null, -1)
  ]))]))
}